<template>
  <Layout>
    <div>
      <PageHeader :title="title" :items="breadCrumbs" :prev="{name:'browse-space',params:{}}"/>
      
      <div class="rent-detail-container">
        <rent-details v-if="businessDetails"/>
        <!-- <span @click="getStoreDetails">RELOAD</span> -->
        <rent-history v-if="businessHistory"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue";
import { listingComputed, listingMethods, layoutMethods, layoutComputed} from "@/state/helpers";
import PageHeader from '@/components/page-header-custom.vue';
import RentDetails from "@/views/pages/listings/rent-details";
import RentHistory from "@/views/pages/listings/rent-history";

export default {
  components: {
    Layout,
    PageHeader,
    RentDetails,
    RentHistory
  },
  computed: {
    ...layoutComputed,
    ...listingComputed
  },
  methods: {
    ...layoutMethods,
    ...listingMethods,
    async getStoreDetails(){
      this.fetchPublicStoreDetails({businessId:this.businessId})
      // .then((res)=>{
      //   this.businessDetails = res.storeDetails;
      //   this.businessHistory = res;
      // });
      this.fetchStoreHistory({businessId:this.businessId})
    }
  },
  data() {
    return {
      businessId:0,
      // businessDetails:null,
      // businessHistory:null,
    };
  },
  mounted(){
    this.businessId = this.$route.params.id;
    // console.log(">> space details:",this.businessId);
    // this.changeTitle({
    //   title: "Store Name "+id,
    // });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Browse Available Space", to: { name: "browse-space" } },
        { text: 'Rental Details', to: { name: 'browse-space-details'} }
      ],
    });
    this.getStoreDetails();
  }
};
/**
 * business information kukunin sa old database (store, name, business type, loc coordinates) any information of business get in old db
 * 
 */
</script>

<style>
.rent-detail-container {
  max-width: 970px;
}
</style>